import api from '../';

class AssociationsGameApi {
    // GET: items
    static getGameItems(params) {
        return api.axios.get('/associations/matrix', { params }).then(response => response.data.matrix);
    }

    static getGroups(locale) {
        return api.axios.get('/associations/groups', { params: { locale } }).then(response => response.data);
    }
}

export default AssociationsGameApi;
